import resourceMixin from '@core/Util/Mixins/resources';
import Modal,{sizes} from '@core/Components/Util/Modal.vue';

import { createNamespacedHelpers } from 'vuex';
const {mapActions,mapGetters,mapState} = createNamespacedHelpers('audienceManager/overview');

export default {
    name: 'audience-channels',
    mixins: [resourceMixin],
    components: {
        Modal
    },
    mounted() {
        this.$refs.channels.show();
    },
    methods: {
        async saveChannels() {

            const channels = Object.values(this.values)
                .filter((value) => value.value === true)
                .map((value) => value.name);

            this.loading = true;
            
            try {
                await this.postAudienceChannels({id: this.id, channels});
            } catch(error) {
                console.error(error);
            }
            
            this.loading = false;
            this.$refs.channels.hide();
        },
        cancel() {
            this.$refs.channels.hide();
        },
        ...mapActions(['postAudienceChannels'])
    },
    computed: {
        modalSize() {
            return sizes.small;
        },
        audience() {
            return this.getAudience(this.id);
        },
        channelValues() {
            const vm = this;

            return vm.values || (vm.values = Object.assign({}, ...Object.values(vm.channels).map((channel) => {
                return {
                    [channel.id]: { 
                        name: channel.name,
                        value: vm.audience.channels.indexOf(channel.name) !== -1 ? true : false
                    }
                };
            })));
        },
        ...mapGetters(['getAudience']),
        ...mapState(['channels'])
    },
    data() {
        return {
            values: null,
            loading: false
        };
    },
    props: {
        id: {
            type: String,
            required: true
        }
    }
};